import { SpinnerLoader, Status, Typography, type IDropdownItem } from 'shared/ui'
import { Icon } from 'shared/ui/Icon'
import { WidgetItem } from 'pages/chatbot/ui/UnifiedAgent/ui/Chat/ui/Widgets'
import styles from 'pages/chatbot/ui/UnifiedAgent/ui/BookingSection/styles.module.scss'

type IBookingStep1Props = {
  items: IDropdownItem[]
  focusedIndex: number
  isLoading: boolean
  onSelect: (index: number) => void
}

export const BookingStep1 = ({ items, focusedIndex, isLoading, onSelect }: IBookingStep1Props) => {
  if (isLoading) {
    return (
      <div className={styles.loading}>
        <SpinnerLoader size={20} ariaLabel={'BookingWidgetStep1'} />
      </div>
    )
  }

  return (
    <div className={styles.list}>
      {items.map((item, index) => {
        const isFocused = index === focusedIndex
        const isConnect = item.labelRight === 'Connect'

        return (
          <WidgetItem
            key={item.id}
            isFocused={isFocused}
            leftNode={<Icon icon={item.iconL} fontSize={20} />}
            onClick={() => onSelect(index)}
            rightNode={isConnect ? <span className={styles.connectBtn}>Connect</span> : undefined}
          >
            <Typography variant={'body-rg-regular'} ariaLabel={item.label}>
              {item.label}
            </Typography>
            {item.iconL !== 'calendly' && (
              <Status title={'New'} intent={'purple'} emphasis={'high'} size={'label'} />
            )}
          </WidgetItem>
        )
      })}
    </div>
  )
}
